export default function Step3PreFlight({
    validCount,
    skippedCount,
    loading,
    error,
    onStart,
    onBack,
}) {
    const estSeconds = validCount * 15;
    const estTime = estSeconds >= 60
        ? `~${Math.floor(estSeconds / 60)}m ${Math.round(estSeconds % 60)}s`
        : `~${Math.round(estSeconds)}s`;

    return (
        <div className="bulk-state">
            <div className="bulk-state-title">Step 3 of 4 · Pre-flight</div>
            <h3>
                Ready to enrich {validCount} {validCount === 1 ? 'property' : 'properties'}
            </h3>

            {error && (
                <div className="bulk-alert-error" role="alert">{error}</div>
            )}

            <div className="preflight-stats">
                <div className="stat-tile success">
                    <div className="stat-label">Valid rows</div>
                    <div className="stat-value">{validCount}</div>
                </div>
                <div className="stat-tile warn">
                    <div className="stat-label">Skipped (errors)</div>
                    <div className="stat-value">{skippedCount}</div>
                </div>
                <div className="stat-tile">
                    <div className="stat-label">Concurrent</div>
                    <div className="stat-value">3</div>
                </div>
                <div className="stat-tile">
                    <div className="stat-label">Est. time</div>
                    <div className="stat-value">{estTime}</div>
                </div>
            </div>

            <p className="bulk-state-sub" style={{ marginBottom: 8 }}>
                Each property runs through Google Places + Claude enrichment + 7 location intel signals. Results stream in below.
            </p>

            <div className="bulk-actions">
                <button type="button" className="btn btn-secondary" onClick={onBack}>← Back</button>
                <button
                    type="button"
                    className="btn btn-primary"
                    disabled={validCount === 0 || loading}
                    onClick={onStart}
                >
                    {loading ? 'Starting…' : 'Start enrichment →'}
                </button>
            </div>
        </div>
    );
}
